module.exports = __webpack_public_path__ + "img/ic_loading.d3e47461.svg";